module.exports = __webpack_public_path__ + "static/media/paytm.be96713e.jpg";